import React from "react";
import type { FC } from "react";
import UtilityPanel from "../layout/UtilityPanel";
import CorePanelFooter from "../layout/CorePanelFooter";
import CoreLayout from "../layout/CoreLayout";
import { IconCaution } from "../icons";
import Button from "../form/Button";
import { useNavigate } from "react-router-dom";
import { useAppStore } from "../../store/appStore";
import { endSession } from "../../api/api";
import { withErrorBoundary } from "../components/withErrorBoundary";

interface Props {
    getSessionId: () => string | null;
    cancelSession: () => void;
}

const AuthzError: FC<Props> = (props) => {
    const { setSessionStatus } = useAppStore();

    const navigate = useNavigate();

    function onNext() {
        const sessionId = props.getSessionId();
        if (sessionId == null) {
            console.error("Session ID is null");
            return;
        }
        endSession(sessionId);
        setSessionStatus("CANCELLED");
    }

    const header = (
        <div className="self-stretch inline-flex justify-start items-center gap-3">
            <IconCaution />
            <div className="flex-1 justify-start font-normal font-['Inter']">
                <div className="text-king-red text-base">
                    We're unable to authorize your account.
                </div>
                <div className="text-king-red text-xs font-normal">
                    An error occurred. Please try again later.
                </div>
            </div>
        </div>
    );

    return (
        <CoreLayout>
            <UtilityPanel headerOverride={header}>
                <div className="flex flex-col gap-4">
                    <div className="text-black text-xs font-normal font-['Inter']">
                        We're sorry for the inconvenience. Our team has been
                        notified of this error. We will investigate and correct
                        this issue promptly.
                    </div>
                    <div className="w-full flex justify-end">
                        <Button onClick={onNext} type="primary">
                            Try Again
                        </Button>
                    </div>
                </div>
            </UtilityPanel>
            <CorePanelFooter>
                <Button onClick={props.cancelSession} type="primary" subType="outline">
                    Cancel
                </Button>
            </CorePanelFooter>
        </CoreLayout>
    );
};

export default withErrorBoundary(AuthzError);
